import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { StructureTableColumn } from "../../../Data/DataTables/CompanyJobs";

//Types
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewCompanyJobs } from "../../../Types/CompanyProfile/CompanyJobs";

//Services
import {
  COMPANY_JOBS_QUERY_KEY,
  VIEW_COMPANY_JOBS_QUERY_KEY,
  companyjobTitleService,
} from "../../../Services/companyjobtitleService";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const CompanyJobsTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const QueryKey = [...VIEW_COMPANY_JOBS_QUERY_KEY, company_code];

  const { data: QueryData = [], isLoading: isLoading } = useQuery<
    ViewCompanyJobs[]
  >({
    queryKey: QueryKey,
    queryFn: () =>
      companyjobTitleService.viewAllJobsByCompany(company_code as string),
    select: (data) =>
      data.sort((a, b) =>
        a.job_title.toLowerCase().localeCompare(b.job_title.toLowerCase()),
      ),
  });

  const filteredItems: ViewCompanyJobs[] = QueryData.filter(
    (item) =>
      item.status === 1 &&
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Job Titles</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Displays all <b>active</b>/<b>available</b> job titles currently set up
        in the system.
      </P>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={StructureTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default CompanyJobsTable;
